<div class="modal-header">
  <h4 class="modal-title">Treino</h4>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">

    <label>Nome</label>
    <input class="form-control mb-2" formControlName="nome">

    <label>Dia da Semana</label>
    <select formControlName="diaSemana" class="form-control">
      <option *ngFor="let dia of [0,1,2,3,4,5,6]" [value]="dia">
        {{ dia === 0 ? 'Domingo' : dia === 1 ? 'Segunda' : dia === 2 ? 'Terça' : dia === 3 ? 'Quarta' : dia === 4 ?
        'Quinta' : dia === 5 ?
        'Sexta' : dia === 6 ? 'Sábado' : 'Domingo' }}
      </option>
    </select>

  </form>
</div>

<div class="modal-footer p-2">
  <div class="row w-100 g-2">
    <div class="col-6">
      <button class="btn btn-outline-secondary w-100" (click)="activeModal.dismiss()">Cancelar</button>
    </div>
    <div class="col-6">
      <button class="btn btn-outline-primary w-100" (click)="submit()">
        Salvar
      </button>
    </div>
  </div>
</div>